import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';

const { baseUrl } = config;

export const attachDealTracker = async (params) => {
  try {
    const qs = utils.getQs(params);
    const url = `${baseUrl}/BioFuelRequirementOffers/api/Deal/AttachDealTracker`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    let resData = await utils.processApiRes(res);
    resData = resData?.map((item) => ({ ...item, id: item.link_id }));
    return resData;
  } catch (err: any) {
    const errors = await utils.processApiErrors(err, '', 'attachDealTracker');
    throw errors;
  }
};
